/**
 * @author lifei
 * 功能：loading
 */
import { createVNode, render, type VNode } from 'vue'
import { Base } from '../base'
import { XHLoading } from '@/components'
import { first } from 'lodash-es'

export class Loading extends Base {
  public constructor() {
    super()
  }

  static {
    Base.register(this)
  }

  /**
   * 功能：队列
   */
  private queue: Array<VNode> = []

  /**
   * 功能：保存 container 状态
   */
  private container: TCommon.OrNull<HTMLDivElement> = null

  /**
   * 功能：创建包裹容器
   * @returns Promise<HTMLDivElement> 容器
   */
  private createContainer = (): Promise<HTMLDivElement> => {
    const container = document.createElement('div')
    container.id = `com-${this.prefix}-loading`
    Object.assign(container.style, {
      width: '100vw',
      height: '100vh',
      position: 'fixed',
      top: 0,
      left: 0,
      zIndex: 9999,
      dispaly: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    })
    document.body.appendChild(container)
    this.container = container
    return Promise.resolve(container)
  }

  /**
   * 功能：显示 loading
   * @param title 展示的文案信息
   */
  public async show(title: string): Promise<void> {
    const vnode = createVNode(XHLoading, { title, spinning: false })
    this.queue.push(vnode)
    if (!this.container) {
      this.container = await this.createContainer()
    }
    const el = first(this.queue)
    if (el?.props) {
      el.props.spinning = true
    }
    el && this.container && render(el, this.container)
  }

  /**
   * 功能：删除 loading
   */
  public hide() {
    this.queue.shift()
    if (this.queue.length === 0) {
      if (this.container) {
        render(null, this.container)
        this.container && document.body.removeChild(this.container)
        this.container = null
      }
    } else if (this.queue.length > 0) {
      const nextEl = first(this.queue)
      if (nextEl?.props) {
        nextEl.props.spinning = true
      }
      nextEl && this.container && render(nextEl, this.container)
    }
  }
}

export const loading = new Loading()
